import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {BarChart, ChartsLabelMark} from '@mui/x-charts';
import {XYVO} from "@/service/analyze";
import {useMemo} from "react";
import {OptionType} from "@/model/global";
import {BarSeriesType} from "@mui/x-charts/models/seriesType/bar";

export interface WriteStatusDistProps {
    writeCopyrightStatus: XYVO[]
    writePatentStatus: XYVO[]
    writeProjectStatus: XYVO[]
    writeTrademarkStatus: XYVO[]
    option: OptionType
    loading: boolean
}

const colors: string[] = ["#6DE1D2", "#F7CFD8", "#67AE6E"]

export default function WriteStatusDist({option, loading, writeCopyrightStatus, writePatentStatus, writeProjectStatus, writeTrademarkStatus}: WriteStatusDistProps) {
    const {xDatas, series, legends} = useMemo(() => {
        let writeStatus: XYVO[] = []
        switch (option?.value) {
            case 1:
                writeStatus = writeProjectStatus
                break
            case 2:
                writeStatus = writePatentStatus
                break
            case 3:
                writeStatus = writeTrademarkStatus
                break
            case 4:
                writeStatus = writeCopyrightStatus
                break
        }
        const legends = [{label: '进行中', value: 'doing', color: colors[0]},
            {label: '暂停中', value: 'pause', color: colors[1]},
            {label: '已完成', value: 'done', color: colors[2]},];
        if (writeStatus) {
            const xDatas: string[] = writeStatus?.map(item => item.x)
            const series: BarSeriesType[] = legends.map((legend, index: number) => {
                const data = writeStatus.map(item => {
                    const value = item[legend.value]
                    return value || 0
                })
                return {data, type: 'bar', color: colors[index]}
            })
            return {xDatas, series, legends}
        }
        return {xDatas: [], series: [], legends: []}
    }, [writeCopyrightStatus, writePatentStatus, writeTrademarkStatus, writeProjectStatus, option])
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack alignContent={'start'} alignItems={'start'} direction={'row'} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        撰写状态分布
                    </Typography>
                    <Stack alignItems={'start'} direction={'row'} spacing={2}>
                        {legends?.map((item, index: number) => <Stack key={index}
                                                                      alignItems={'center'} spacing={1} direction={'row'}>
                            <ChartsLabelMark type={'square'} color={item.color}/>
                            <Typography sx={{display: 'inline-block', alignItems: 'start'}}>{item.label}</Typography>
                        </Stack>)}
                    </Stack>
                </Stack>
                <BarChart
                    height={180}
                    xAxis={[{data: xDatas, barGapRatio: 1, categoryGapRatio: 0.0}]}
                    series={series}
                    yAxis={[{width: 26, disableTicks: true, disableLine: true,}]}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                />
            </CardContent>
        </Card>
    );
}
